import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity'
import FilterWrapper from './FilterWrapper';
import Popup from '../Common/Popup';

function ExitTypeFilter({ open, accordionClick }) {

    const { ExitType, setExitType, selectedExitTypeLength } = useContext(PeFilterContext);

    const handleExitTypeChange = (e) => {
        const { name, checked, id, selectedEntities, filteredIds } = e.target;
        let updatedExitTypes;
    
        if (name === "allSelect") {
            updatedExitTypes = ExitType.map(exitstype => ({ ...exitstype, isChecked: checked }));
        } else if (name === "filteredSelect" && filteredIds) {
            updatedExitTypes = ExitType.map(exitstype => ({
                ...exitstype,
                isChecked: filteredIds.includes(parseInt(exitstype.id)) ? checked : exitstype.isChecked
            }));
        } else if (name === "selectedEntities" && selectedEntities) {
            const selectedEntityIds = selectedEntities.map(entity => parseInt(entity.id));
            updatedExitTypes = ExitType.map(exitstype => ({
                ...exitstype,
                isChecked: selectedEntityIds.includes(exitstype.id) ? !exitstype.isChecked : exitstype.isChecked
            }));
        } else {
            updatedExitTypes = ExitType.map(exitstype =>
                exitstype.id === parseInt(id) ? { ...exitstype, isChecked: checked } : exitstype
            );
        }
    
        setExitType(updatedExitTypes);
    };

    return (
        <div className="border-b-[3px] border-[#E8E6E1]">
            <li
                className={
                    open
                        ? "bg-white relative px-3 py-1"
                        : "relative px-3 py-1"
                }
            >
                <button
                    type="button"
                    className="w-full text-left"
                    onClick={accordionClick}
                >
                    <div className="flex items-center justify-between">
                        <span className="text-[#333333] text-[14px] leading-[17px] tracking-[-0.3px]">Type - Public Market (PE-VC)</span>
                        {open ? (

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-[17px] w-[17px] rotate-180 cursor-pointer transition-transform duration-200 mt-3 top-1/2 transform -translate-y-1/2 right-3"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M19 9l-7 7-7-7"
                                />
                            </svg>

                        ) : (
                            <div className='flex items-center  gap-4'>
                                <div className='mt-3'>
                                    <span className={selectedExitTypeLength > 0 ? "bg-[#BC8B20] text-white rounded-full text-[12px] p-0.5 items-center justify-center flex " + (selectedExitTypeLength < 99 ? 'h-4 w-4' : '') : ''}> {selectedExitTypeLength > 0 ? selectedExitTypeLength : ""}</span>
                                </div>
                                <div className='mt-3'>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-[17px] w-[17px] rotate-0 cursor-pointer transition-transform duration-200 mt-[0.5rem]  top-1/2 transform -translate-y-1/2 right-3"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M19 9l-7 7-7-7"
                                        />
                                    </svg>
                                </div>
                            </div>
                        )}
                    </div>
                </button>

                <div
                    className="relative overflow-hidden transition-all max-h-0 duration-700  overflow-y-auto no-scrollbar"
                    style={{ maxHeight: open ? "10rem" : "" }}
                >

                    {open === true ? <MultiSelectEntity
                        handleEntityChange={handleExitTypeChange}
                        primaryEntity={ExitType}
                    /> : <></>}

                </div>

            </li>

        </div>
    )
}

/**
 * The `SelectTypeFilter` function is a React component that renders a dropdown select input for
 * filtering options based on a selected exit type.
 * @returns a JSX element.
 */
function SelectTypeFilter({ TypeOptions, setTypeOptions, customPathname, heading = "Type", isPopupOpen, setIsPopupOpen }) {
    const { ExitType, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    
    // Use centralized state if provided, otherwise fall back to internal state
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const typeIds = refineSearchFilters[customPathname]?.exitType?.map(value => value.id) ?? [];
        setTypeOptions(ExitType?.map(type => ({ ...type, isChecked: typeIds.includes(parseInt(type.id)) })))
    }, [ExitType, customPathname, refineSearchFilters, setTypeOptions]);

    const handleChange = (e) => {
        const { value } = e.target;
        const currentTypes = TypeOptions.map((type) =>
            ({ ...type, isChecked: type.id === parseInt(value) })
        );
        setTypeOptions(currentTypes);
    };

    const selected = TypeOptions?.filter(type => type.isChecked)?.at(0);

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{heading} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {TypeOptions.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4 pr-2">
                        {/* <label className="block text-sm font-medium text-gray-700 mb-2">
                            {heading}
                        </label> */}
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto">
                                <label className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="selectType"
                                        value=""
                                        checked={!selected}
                                        onChange={handleChange}
                                        className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                    />
                                    <span className="text-[13px] font-semibold">All</span>
                                </label>
                                <div className='grid grid-cols-2'>
                                {TypeOptions?.map(type => (
                                    <label key={type.id} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                        <input
                                            type="radio"
                                            name="selectType"
                                            value={type.id}
                                            checked={selected?.id === type.id}
                                            onChange={handleChange}
                                            className="text-[#BC8B20] focus:ring-[#BC8B20]"
                                        />
                                        <span className="text-[13px] font-semibold">{type.name}</span>
                                    </label>
                                ))}
                            </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    );
}

export { SelectTypeFilter };
export default ExitTypeFilter